(() => {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const busyForms = new WeakSet();

  function isPersonalizedForm(form) {
    return form instanceof HTMLFormElement && form.dataset.mellowdenPersonalization === '1';
  }

  function setButtonText(button, text) {
    if (!button) return;
    const textNode = button.querySelector('.add-to-cart-text__content > span > span');
    if (textNode) textNode.textContent = text;
    else if (button.tagName === 'INPUT') button.value = text;
    else button.textContent = text;
  }

  function getButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"], button[data-mdp-go-to-cart="true"]');
  }

  function showError(form, message) {
    const box = form.querySelector('.mdp-error');
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearError(form) {
    const box = form.querySelector('.mdp-error');
    if (!box) return;
    box.textContent = '';
    box.hidden = true;
  }

  function updateCartBadge(cart) {
    const badge = document.querySelector('.mdh-cart-count');
    if (!badge) return;
    const count = Number(cart && cart.item_count) || 0;
    badge.textContent = String(count);
    badge.hidden = count < 1;
  }

  async function addOnce(form, button) {
    if (busyForms.has(form)) return;
    if (button?.dataset.mdpGoToCart === 'true') {
      window.location.assign(ROOT + 'cart');
      return;
    }

    const photo = form.querySelector('input[name="properties[Pet photo]"]');
    const background = form.querySelector('select[name="properties[Background preference]"]');
    const custom = form.querySelector('input[name="properties[Custom background]"]');

    if (!photo?.files?.length) {
      showError(form, 'Please upload a pet photo before continuing.');
      photo?.focus();
      return;
    }
    if (background?.value === 'Custom' && !custom?.value.trim()) {
      showError(form, 'Please describe the custom background you want.');
      custom?.focus();
      return;
    }
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    clearError(form);
    busyForms.add(form);
    const submit = button || getButton(form);
    const originalText = submit ? (submit.textContent || submit.value || 'Add to cart').trim() : 'Add to cart';

    if (submit) {
      submit.removeAttribute('data-added');
      submit.disabled = true;
      submit.setAttribute('aria-disabled', 'true');
      setButtonText(submit, 'Adding…');
    }

    try {
      const formData = new FormData(form);
      const variantId = String(formData.get('id') || '');
      const response = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.status) {
        throw new Error(payload.description || payload.message || 'We couldn’t add this portrait to your cart. Please try again.');
      }

      const cartResponse = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Your cart could not be confirmed. Please try again.');
      const cart = await cartResponse.json();
      const added = Array.isArray(cart.items) && cart.items.some((item) => String(item.variant_id) === variantId);
      if (!added) throw new Error('The portrait was not added to your cart. Please try again.');

      updateCartBadge(cart);
      if (submit) {
        submit.dataset.mdpGoToCart = 'true';
        submit.type = 'button';
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
        submit.removeAttribute('data-added');
        setButtonText(submit, 'Go to cart');
      }
    } catch (error) {
      console.error('[Mellowden cart guard]', error);
      if (submit) {
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
        submit.removeAttribute('data-added');
        setButtonText(submit, originalText || 'Add to cart');
      }
      showError(form, error?.message || 'We couldn’t add this portrait to your cart. Please try again.');
    } finally {
      busyForms.delete(form);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[type="submit"], input[type="submit"], button[data-mdp-go-to-cart="true"]');
    if (!button) return;
    const form = button.closest('form');
    if (!isPersonalizedForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addOnce(form, button);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isPersonalizedForm(form)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    addOnce(form, getButton(form));
  }, true);
})();